"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructsFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "outers",
        outputs: [
            {
                internalType: "uint256",
                name: "sentinel",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "a",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "b",
                type: "uint16",
            },
            {
                internalType: "uint128",
                name: "c",
                type: "uint128",
            },
        ],
        name: "writeEach",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "a",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "b",
                type: "uint16",
            },
            {
                internalType: "uint128",
                name: "c",
                type: "uint128",
            },
        ],
        name: "writeOnce",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610314806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80633e9adda9146100465780637e31c3741461005b578063b3add55a14610084575b600080fd5b610059610054366004610214565b610097565b005b61006e6100693660046101ee565b61012c565b60405161007b9190610284565b60405180910390f35b610059610092366004610214565b61013e565b61009f6101a7565b506040805160608101825261ffff948516815292841660208085019182526001600160801b03938416858401908152600097885287825283882033895260010190915291909520925183549551915161ffff199096169085161763ffff0000191662010000919094160292909217600160201b600160a01b031916600160201b9390921692909202179055565b60006020819052908152604090205481565b600093845260208481526040808620338752600101909152909320805461ffff191661ffff9384161763ffff0000191662010000929093169190910291909117600160201b600160a01b031916600160201b6001600160801b0390931692909202919091179055565b604080516060810182526000808252602082018190529181019190915290565b80356101d2816102a8565b92915050565b80356101d2816102bf565b80356101d2816102c8565b60006020828403121561020057600080fd5b600061020c84846101e3565b949350505050565b6000806000806080858703121561022a57600080fd5b600061023687876101e3565b9450506020610247878288016101d8565b9350506040610258878288016101d8565b9250506060610269878288016101c7565b91505092959194509250565b61027e816102a5565b82525050565b602081016101d28284610275565b6001600160801b031690565b61ffff1690565b90565b6102b181610292565b81146102bc57600080fd5b50565b6102b18161029e565b6102b1816102a556fea365627a7a72315820d0aab50a3db59a664fda63ca08bc5b44949900eda22199124e93006d474c54b06c6578706572696d656e74616cf564736f6c63430005100040";
class StructsFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StructsFactory = StructsFactory;
StructsFactory.bytecode = _bytecode;
StructsFactory.abi = _abi;
//# sourceMappingURL=StructsFactory.js.map